import { render, staticRenderFns } from "./BatchORGrid.vue?vue&type=template&id=5188caea&scoped=true&"
import script from "./BatchORGrid.vue?vue&type=script&lang=js&"
export * from "./BatchORGrid.vue?vue&type=script&lang=js&"
import style0 from "./BatchORGrid.vue?vue&type=style&index=0&id=5188caea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188caea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
